module.exports = __webpack_public_path__ + "img/shi.1589c734.png";